module.exports = __webpack_public_path__ + "static/4fe7a04f1dc4519508cf018366693a352891a54ef5561f09d2c324a213b47bb2-5a5277b13db606ed9bce57ed63355a50.png";